module.exports = __webpack_public_path__ + "img/San_fran_bridge.07bc7efa.jpg";